import { Stores } from '../models/Stores';

export class BaseStore {
    stores: Stores;

    constructor(stores: Stores) {
        this.stores = stores;
    }
}



// WEBPACK FOOTER //
// ./src/stores/BaseStore.ts